import '../cart.js';
import 'slick-carousel';

$(document).ready(function () {
    //-- Linked products => add to cart
    AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);

    $('button[data-id="show_explicit_content"]').click(function () {
        // Save sortorder in session
        $.post(strAjaxPath + 'explicit_content.php', 'value=' + $(this).attr('data-value'), function () {
            // Load articles
            //LoadArticles();
            window.location.reload();
        }, 'json');
        return false;
    });
});


$('document').ready(function () {
    if ($('[data-block-id=\'230\']').length > 0) {

        $('.slider-row').on('init', function (event, slick) {
            $('form.form-add-to-cart button.btn-basket').unbind("click");
            AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
        });

        if ($('body').hasClass('index')) {
            $('[data-block-id=\'230\']').each(function () {
                var objSliderProducts = $(this).find('.slider-row').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 1080,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 555,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            });
        } else {
            $('[data-block-id=\'230\']').each(function () {
                var objSliderProducts = $(this).find('.slider-row').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 1080,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 578,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            });
        }
    }
});
